import React, { useReducer, useContext } from "react";
import { policyPlanCustomRecordTemplateReducer as reducer } from "../reducers/policyPlanCustomRecordTemplateReducer";
import { policyPlanCustomRecordTemplateActions as actions } from "../actions/policyPlanCustomRecordTemplateActions";

const initialValue = {
  templates: null,
  showModal: false,
  currentTemplate: null,
};

const policyPlanCustomRecordTemplateContext = React.createContext();

const PolicyPlanCustomRecordTemplateContext = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <policyPlanCustomRecordTemplateContext.Provider
      value={{ state, dispatch, actions }}
    >
      {children}
    </policyPlanCustomRecordTemplateContext.Provider>
  );
};

export const usePolicyPlanCustomRecordTemplateContext = () =>
  React.useContext(policyPlanCustomRecordTemplateContext);
export default PolicyPlanCustomRecordTemplateContext;
